import React from "react";

const ClearComponent = ({ handleClick }: any) => {
  return (
    <div className="col-auto">
      <span
        role="button"
        className="d-flex align-items-center h-100 text-danger"
        onClick={handleClick}
      >
        Clear
      </span>
    </div>
  );
};

export default ClearComponent;
